module.exports = __webpack_public_path__ + "img/art_track.2ff013aa.svg";